import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#27213d',
                gray: '#D9D9D9',
                dark: '#27213d',
            }
        }
    }
});
